import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';
import { getConclusioniControl } from './helpers/conclusioni-form.helper';

export const conclusioniPropostaSostLiquidatoreRules: FormGroupRules = {
    my_descNatRitardoLiquid: (form: FormGroup) => {
        isEmptyWhenProvvedimentoIs4Or9(form, 'my_SchedaPropostaSostLiquidCancelRegImpre.my_descNatRitardoLiquid');
    },

    my_descUlterMotivaz: (form: FormGroup) => {
        isEmptyWhenProvvedimentoIs4Or9(form, 'my_SchedaPropostaSostLiquidCancelRegImpre.my_descUlterMotivaz');
    },

    my_ckDepBil5Esercizi: (form: FormGroup) => {
        isEmptyWhenProvvedimentoIs4Or9(form, 'my_SchedaPropostaSostLiquidCancelRegImpre.my_ckDepBil5Esercizi');
    },

    my_ckBeniImmob: (form: FormGroup) => {
        isEmptyWhenProvvedimentoIs4Or9(form, 'my_SchedaPropostaSostLiquidCancelRegImpre.my_ckBeniImmob');
    },

    my_ckBeniMobRegistr: (form: FormGroup) => {
        isEmptyWhenProvvedimentoIs4Or9(form, 'my_SchedaPropostaSostLiquidCancelRegImpre.my_ckBeniMobRegistr');
    },

    my_descRisultanzeBil: (form: FormGroup) => {
        isEmptyWhenProvvedimentoIs4Or9(form, 'my_SchedaPropostaSostLiquidCancelRegImpre.my_descRisultanzeBil');
    },
};

const isEmptyWhenProvvedimentoIs4Or9 = (form: FormGroup, targetPath: string) => {
    const targetControl = getConclusioniControl(form, targetPath);
    const my_CkProvvedimendoDi: string = getConclusioniControl(form, 'my_CkProvvedimendoDi').value;
    const targetNameSplitted = targetPath?.split('.');
    const errorName = targetNameSplitted[targetNameSplitted.length - 1];
    const showError = isNilOrEmpty(targetControl.value) && (my_CkProvvedimendoDi === '4' || my_CkProvvedimendoDi === '9');
    const errors = targetControl.errors ? targetControl.errors : {};

    addRemoveError(showError, errors, errorName, {
        status: REQUIRED_STATUS,
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};
